import React, { useState,useEffect } from 'react';
import { useTheme } from '@emotion/react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { Grid } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useMaterialUIController } from "context";
import {TextField} from '@mui/material';
import ReporteRecepcionMatricula from "components/ReporteRecepcionMatricula";
import PDFModal from "components/PDFModal";
import { useApi } from "lib/api";

export default function ConsultaMatriculas() {
  var tcosto = 0.00
  var tvalor = 0.00

  const[rowsdata,setRowsdata] = useState([])
  const[rowsdata2,setRowsdata2] = useState([])
  const[rowsdata3,setRowsdata3] = useState([])
  const[mensaje,setMensaje] = useState("")

  
  const opcionstatus = ['T=Todos','I=Incautados','V=Vendido', 'N=Normal']
  const[chasis,setChasis] = useState("")
  const [detalleMatri,setDetalleMatri] = useState([])
  const [detalleRows2,setDetalleRows2] = useState([])
  const [mostrarDetalleEntrega,setMostrarDetalleEntrega] = useState(false)
  const [existendocumentosentregados,setExistendocumentosentregados] = useState(false)
  
  const[mostrarMensaje,setMostrarMensaje] = useState(false)     
  const[indexEliminar,setIndexEliminar] = useState("")
  
  // Estados para edición de datos de entrega
  const [abrirEdicion,setAbrirEdicion] = useState(false)
  const [datosEdicion,setDatosEdicion] = useState({
    nombres: '',
    apellidos: '',
    cedula: '',
    fecha: '',
    sucursal: '',
    cajero: '',
    localizacion: '',
    documentoentregado:''
  })

  // Estados para eliminación
  const [abrirConfirmacionEliminar,setAbrirConfirmacionEliminar] = useState(false)

  // Estados para el modal de PDF
  const[mostrarPDFModal,setMostrarPDFModal] = useState(false)
  const[pdfUrl,setPdfUrl] = useState("")

  const[controller] = useMaterialUIController()
  const {nombreNegocio,roleWeb} = controller
  const { post } = useApi()
  const [jsondocumentos,setJsondocumentos] = useState([])
  const [detallematriculasentregadas,setDetallematriculasentregadas] = useState([])

  useEffect(() => {
    post('/api/consultarmatricula')
    .then(function({ status, data }){
      if (status === 200) {
            //rows = [data["facturacion"]]
            setRowsdata(data["matriculas"])
            setRowsdata2(data["matriculas2"])
            setRowsdata3(data["pagomatri"])

      }
      if (status === 400) {
//            alert(data["Error"])

      }})
  },[]);

  
  useEffect(() => {
    if (detalleRows2 && detalleRows2.sucursaldocumentos) {
      try {
        setJsondocumentos([JSON.parse(detalleRows2.sucursaldocumentos)])
        let arrayjson = []
        let json_str = null
      
        if(JSON.parse(detalleRows2.sucursaldocumentos).documentos){
          if (JSON.parse(detalleRows2.sucursaldocumentos).documentos.includes("*")){
            json_str = JSON.parse(detalleRows2.sucursaldocumentos).documentos.split("*")  
          } else {
            json_str = JSON.parse(detalleRows2.sucursaldocumentos).documentos 
          }
        } else {
          json_str = null 
        }
        //let txtjson = JSON.parse(detalleRows2.sucursaldocumentos).documentos.split("*")
        let txtjson = json_str
        
        if(txtjson){
          txtjson.map((item,i) => {
            arrayjson.push(JSON.parse(item))
          })
        } else { arrayjson.push([]) }
        setJsondocumentos(arrayjson)
        

      } catch (error) {
        console.error('Error parsing sucursaldocumentos:', error)
        setJsondocumentos([])
      }
    } else {
      setJsondocumentos([])
    }
  },[detalleRows2]);

  
  
  function handlechasis(valor){
    setChasis(valor)
    
    if(typeof valor == "string" && valor.length > 0){
      setDetalleMatri(rowsdata3.filter(value => value.chasis==valor))
      setDetalleRows2(rowsdata2.find(value => value.chasis==valor))

      console.log("detalleRows2",detalleRows2)
      console.log("rowsdata2",rowsdata2)
      const existendocentregados = rowsdata2.filter(value => value.chasis==valor)
      if(existendocentregados.sucursaldocumentos){
        const existendocentregados2 = JSON.parse(existendocentregados.sucursaldocumentos).filter(value => value.entregado == true)
        setExistendocumentosentregados(existendocentregados2)
      } else {
        setExistendocumentosentregados(false)
      }

      {/*Descomponer array de matriculas entregadas */}
      if(existendocentregados[0]){
        
        console.log("entregados")
        let json_detalleentregados = null
      
        if(existendocentregados[0].cajeromatriculaentregada){
          if (existendocentregados[0].cajeromatriculaentregada.includes("*")){
            console.log("json_detalleentregados",existendocentregados[0].cajeromatriculaentregada.split("*"))
            json_detalleentregados = existendocentregados[0].cajeromatriculaentregada.split("*")

          } else {
            json_detalleentregados = [JSON.parse(existendocentregados[0].cajeromatriculaentregada)] 
          }
        } else {
          json_detalleentregados = null 
        }
     
        console.log("4")
        //const detallematriculasentregadas1 = existendocentregados[0].cajeromatriculaentregada.split("*")
        const detallematriculasentregadas1 = []
        if (json_detalleentregados) {
          if (json_detalleentregados.length > 1) {
            json_detalleentregados.map((item,i) => {
              detallematriculasentregadas1[i] = JSON.parse(item) 
            })
          } else { detallematriculasentregadas1.push(json_detalleentregados[0]) }
        }
        console.log(detallematriculasentregadas1)         
        setDetallematriculasentregadas(detallematriculasentregadas1 ? detallematriculasentregadas1 : [])
        
      }
      //const detalledeentregados = existendocentregados.sucursaldocumentos.split("*")
      //console.log("detalledeentregados",detalledeentregados)      
    }
  }

  function buscar(){
    var item = rowsdata2.filter(value => value['chasis']===chasis);    
    if(item.length!=0){
      setMensaje("Matricula disponible")
    }

}

  function consultarDetalleEntrega(){
    if(chasis && chasis !== ""){
      setMostrarDetalleEntrega(true)
      // Aquí se puede agregar lógica adicional para consultar más detalles del backend
    } else {
      setMensaje("Por favor seleccione un chasis primero")
    }
  }

  function abrirEdicionDatos(index){
    console.log("index",index)
    if(chasis && chasis !== "" && detalleRows2){
      console.log("detalleRows2",detalleRows2)
      

      const matriculaaeditar = detalleRows2['cajeromatriculaentregada'].split("*")
      console.log("matriculaaeditar",JSON.parse(matriculaaeditar[index]).nombres)
      
      setDatosEdicion({
        nombres: JSON.parse(matriculaaeditar[index]).nombres || '',
        apellidos: JSON.parse(matriculaaeditar[index]).apellidos || '',
        cedula: JSON.parse(matriculaaeditar[index]).cedula || '',
        fecha: JSON.parse(matriculaaeditar[index]).fecha || '',
        sucursal: JSON.parse(matriculaaeditar[index]).sucursalentrega || '',
        cajero: JSON.parse(matriculaaeditar[index]).cajero || '',
        localizacion: JSON.parse(matriculaaeditar[index]).localizacion || '',
        documentoentregado: JSON.parse(matriculaaeditar[index]).documentoentregado || ''
      })
      
      setAbrirEdicion(true)
    } else {
      setMensaje("Por favor seleccione un chasis primero")
    }
  }

  async function guardarCambios(){
    const { status, data } = await post('/api/transferenciabackend_actualizarmatricula', {
      'chasis': chasis,
      'datos': datosEdicion
    })
    if (status === 200) {
      setMensaje("Datos actualizados correctamente")
      setMostrarMensaje(true)
      setAbrirEdicion(false)
      setMostrarDetalleEntrega(false)
      setChasis("")
      // Recargar todos los datos de la pantalla
      const { status: refreshStatus, data: refreshData } = await post('/api/consultarmatricula')
      if (refreshStatus === 200) {
        setRowsdata(refreshData["matriculas"])
        setRowsdata2(refreshData["matriculas2"])
        setRowsdata3(refreshData["pagomatri"])
      }
    }
    if (status === 400) {
      setMensaje("Error al actualizar: " + data["Error"])
      setMostrarMensaje(true)
    }
  }

  function abrirDialogoConfirmacionEliminar(index){
    if(chasis && chasis !== ""){
      setIndexEliminar(index)
      setAbrirConfirmacionEliminar(true)
    } else {
      setMensaje("Por favor seleccione un chasis primero")
      setMostrarMensaje(true)
    }
  }

  async function eliminarMatricula(){
    
    {/*Eliminar los datos de la matricula entregada*/}
    const matriculaaeliminar1 = detalleRows2['cajeromatriculaentregada'].split("*")
    const matriculaaeliminar = JSON.parse(matriculaaeliminar1[indexEliminar])
    

    console.log(detalleRows2['sucursaldocumentos'],"manuelnuevo18") 
    const statusdocumentos = JSON.parse(detalleRows2['sucursaldocumentos'])['documentos']
    console.log(statusdocumentos,"manuelnuevo17")
    
    let statusdocumentos1 = []
    if (statusdocumentos.includes("*")  ){
      statusdocumentos.split("*").map((item,i) => {
        statusdocumentos1[i] = JSON.parse(item)
      })
    } else {
      statusdocumentos1 = JSON.parse(statusdocumentos)
    }
    
    console.log(statusdocumentos1)
    const { status, data } = await post('/api/transferenciabackend_eliminarrecepcion', {
      'chasis': chasis,
      'documentoentregado': matriculaaeliminar.documentoentregado,
      'jsonamodificar': detalleRows2['cajeromatriculaentregada'],
      'indexEliminar': indexEliminar,
      'validaciondeentrega': statusdocumentos1,
    })
    if (status === 200) {
      setMensaje("Recepcion eliminada correctamente")
      setMostrarMensaje(true)
      setAbrirConfirmacionEliminar(false)
      setMostrarDetalleEntrega(false)
      setChasis("")

      // Recargar todos los datos de la pantalla
      const { status: refreshStatus, data: refreshData } = await post('/api/consultarmatricula', {
        'chasis': chasis
      })
      if (refreshStatus === 200) {
        setRowsdata(refreshData["matriculas"])
        setRowsdata2(refreshData["matriculas2"])
        setRowsdata3(refreshData["pagomatri"])
      }
    }
    if (status === 400) {
      setMensaje("Error al eliminar recepcion: " + data["Error"])
      setMostrarMensaje(true)
    }
  }

  function generarReporteRecepcion(index){
    if(chasis && chasis !== "" && detalleRows2){
      // Preparar datos de la matrícula
      
      const matriculaaeditar = detalleRows2['cajeromatriculaentregada'].split("*")
      console.log("matriculaaeditar",JSON.parse(matriculaaeditar[index]).nombres)
      
      const datosMatricula = {
        chasis: chasis,
        nombres: JSON.parse(matriculaaeditar[index]).nombres || '',
        apellidos: JSON.parse(matriculaaeditar[index]).apellidos || '',
        cedula: JSON.parse(matriculaaeditar[index]).cedula || '',
        fecha: JSON.parse(matriculaaeditar[index]).fecha || '',
        sucursal: JSON.parse(matriculaaeditar[index]).sucursalentrega || '',
        cajero:   JSON.parse(matriculaaeditar[index]).cajero || '',
        localizacion: JSON.parse(matriculaaeditar[index]).localizacion || '',
        documentoentregado: JSON.parse(matriculaaeditar[index]).documentoentregado || ''
      }

      

      // Preparar datos de pago si existen
      let datosPago = null;
      if(detalleMatri && detalleMatri.length > 0){
        const pago = detalleMatri[0]; // Tomar el primer pago
        datosPago = {
          valor: pago.valor || '',
          fecha: pago.fecha || '',
          recibido: pago.recibido || '',
          descripcion: pago.descripcion || ''
        }
      }

      // Generar PDF y mostrar en modal
      const url = ReporteRecepcionMatricula.generarReporteParaModal(datosMatricula, datosPago);
      setPdfUrl(url);
      setMostrarPDFModal(true);
    } else {
      setMensaje("Por favor seleccione un chasis con datos de entrega primero")
      setMostrarMensaje(true)
    }
  }

  function cerrarPDFModal(){
    setMostrarPDFModal(false);
    // Limpiar la URL para liberar memoria
    if(pdfUrl){
      URL.revokeObjectURL(pdfUrl);
      setPdfUrl("");
    }
  }


    return(
     
     <Box component="main" > 
        <Grid container >
              <Grid item xs={12} md={12} lg={12} marginLeft={'20px'}>
                <Typography variant="h4" fontWeight={"bold"} >{"Buscar Chasis"}</Typography>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <Autocomplete
                    style={{marginTop:"15px",marginLeft:"20px",width:"35%"}}
                    variant = "standard"    
                    disablePortal
                    id="combo-box-demo"
                    options={rowsdata}
                    value = {chasis}
                    onInputChange={(event,newValue)=>{handlechasis(newValue);}}
                    onChange={(event,newValue)=>{handlechasis(newValue);}}
                    onBlur={(event) => handlechasis(event.target.value)}
                    renderInput={(params) => 
                      <TextField {...params}  
                        label="Busqueda" 
                        slotProps={{
                        input: {
                          ...params.InputProps,
                          type: 'search',
                        },
                      }}/>}                    
                  />
              </Grid>
              
              <Grid item xs={12} md={12} lg={12} style={{marginTop:"15px",marginLeft:"20px"}}>
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={consultarDetalleEntrega}
                  disabled={!chasis || chasis === ""}
                  style={{marginRight:"10px",color:"white"}}
                >
                  Consultar Detalle de Entrega
                </Button>
                <Button 
                  variant="contained" 
                  color="primary"
                  style={{color:"white"}} 
                  onClick={() => setMostrarDetalleEntrega(false)}
                  disabled={!mostrarDetalleEntrega}
                >
                  Ocultar Detalle
                </Button>
              </Grid>
              
              {detalleMatri?.map((item,i) => (
              
                <Grid item xs={12} md={6} lg={3}>
                
                  <Box width={550} height={275} borderRadius={3} boxShadow={5} style={{backgroundColor:'white',padding:20, marginTop:20, marginLeft:20}} >
                    
                    <Grid container>
                      <Grid item lg={12} style={{backgroundColor:"white"}}>
                        <h3>Detalle Pagos</h3>
                      </Grid>          

                      <Grid item lg={6} marginTop={2}>
                        <p style={{fontWeight:"bold",fontSize:14}}>Nombre:</p>
                      </Grid>  
                      <Grid item lg={6} marginTop={2}>
                        <p style={{fontSize:14}}>{item==undefined?"-":item.nombres}</p>
                      </Grid>  

                      <Grid item lg={6} >
                        <p style={{fontWeight:"bold",fontSize:14}}>Apellido:</p>
                      </Grid>  
                      <Grid item lg={6}>
                        <p style={{fontSize:14}}>{item==undefined?"-":item.apellidos}</p>
                      </Grid>  
                      <Grid item lg={6}>
                        <p style={{fontWeight:"bold",fontSize:14}}>Pagado:</p>
                      </Grid>  
                      <Grid item lg={6}>
                        <p style={{fontSize:14}}>{item==undefined?"-":item.valor}</p>
                      </Grid>
                      
                      <Grid item lg={6}>
                        <p style={{fontWeight:"bold",fontSize:14}}>Fecha:</p>
                      </Grid>  
                      
                      <Grid item lg={6}>
                        <p style={{fontSize:14}}>{item==undefined?"-":item.fecha}</p>
                      </Grid>
                      
                      <Grid item lg={6}>
                        <p style={{fontWeight:"bold",fontSize:14}}>Recibido:</p>
                      </Grid>  
                      <Grid item lg={6}>
                        <p style={{fontSize:14}}>{item==undefined?"-":item.recibido}</p>
                      </Grid>
                      
                      <Grid item lg={6}>
                        <p style={{fontWeight:"bold",fontSize:14}}>Endoso:</p>
                      </Grid>  
                      <Grid item lg={6}>
                        <p style={{fontSize:14}}>{item==undefined?"-":item.endoso}</p>
                      </Grid>
                      

                      {item.localizacion.length > 0 ? (
                      <>  
                        <Grid item lg={6}>
                          <p style={{fontWeight:"bold",fontSize:14}}>Localizacion</p>
                        </Grid>  
                        <Grid item lg={6}>
                          <p style={{fontSize:14}}>{item==undefined?"-":item.localizacion}</p>
                        </Grid>
                        </>
                      ):''}
                      
                      {existendocumentosentregados ? (
                        <>
                        <Grid item lg={6}>
                              <p style={{fontWeight:"bold",fontSize:14}}>Entregas:</p>
                        </Grid>
                      
                        {jsondocumentos?.map((item,i) => ( 
                          <>          
                          {item.entregado == true ? 
                            <Grid item lg={1.5}>
                              <p style={{fontSize:18,color:"red"}}>{item==undefined?"-":'['+item.documentos+']'}</p>
                            </Grid>
                          :''}
                          </>
                        ))}
                        </>
                      ):''}  
                      
                    </Grid>
                    
                  </Box>
                
                </Grid>
              ))}

              
              {mostrarDetalleEntrega && detalleRows2 && (
                detallematriculasentregadas.map((item,i) => (
                  <>
                  <Grid item xs={12} md={12} lg={12} style={{marginTop:20, marginLeft:20}}>
                    <Box padding={4} style={{backgroundColor:"white", borderRadius:8, boxShadow:3, border:"1px solid #e0e0e0"}}>
                      <Typography variant="h5" style={{marginBottom:20, color:"#1976d2", fontWeight:"bold"}}>
                        Detalle de Entrega de Matrícula
                      </Typography>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                          <Typography variant="subtitle1" style={{fontWeight:"bold", color:"#333"}}>
                            Información del Cliente:
                          </Typography>
                          <Box style={{marginTop:10, padding:15, backgroundColor:"#f5f5f5", borderRadius:5}}>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <Typography variant="body2" style={{fontWeight:"bold"}}>Nombres:</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="body2">{item.nombres || 'N/A'}</Typography>
                              </Grid>
                              
                              <Grid item xs={6}>
                                <Typography variant="body2" style={{fontWeight:"bold"}}>Apellidos:</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="body2">{item.apellidos || 'N/A'}</Typography>
                              </Grid>
                              
                              <Grid item xs={6}>
                                <Typography variant="body2" style={{fontWeight:"bold"}}>Cédula:</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="body2">{item.cedula || 'N/A'}</Typography>
                              </Grid>
                              
                              <Grid item xs={6}>
                                <Typography variant="body2" style={{fontWeight:"bold"}}>Documento Entregado:</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="body2" style={{color:  'green' }}>{item.documentoentregado || 'N/A'}</Typography>
                              </Grid>

                            </Grid>
                          </Box>
                            <Box>
                              {(roleWeb=="AdmG" || roleWeb=="Administrador") && item.nombres.length != 0 ?
                                <>
                                <Button 
                                  variant="contained" 
                                  color="primary" 
                                  onClick={() => generarReporteRecepcion(i)}
                                  disabled={!chasis || chasis === ""}
                                  style={{marginRight:"10px",color:"white",marginTop:10}}
                                >
                                  Generar Reporte PDF
                                </Button>
                                <Button 
                                  variant="contained"  
                                  onClick={() => abrirEdicionDatos(i)}
                                  style={{marginRight:"10px",color:"white",marginTop:10}}
                                >
                                  Editar Datos
                                </Button>
                                <Button 
                                  variant="contained"  
                                  onClick={() => abrirDialogoConfirmacionEliminar(i)}
                                  style={{marginRight:"10px",color:"white",marginTop:10}}
                                >
                                  Eliminar Entrega
                                </Button>
                                
                                </>
                              :''}
                            </Box>
                          
                        </Grid>
                        
                        <Grid item xs={12} md={6}>
                          <Typography variant="subtitle1" style={{fontWeight:"bold", color:"#333"}}>
                            Información de Entrega:
                          </Typography>
                          <Box style={{marginTop:10, padding:15, backgroundColor:"#f5f5f5", borderRadius:5}}>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <Typography variant="body2" style={{fontWeight:"bold"}}>Fecha de Entrega:</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="body2">{item.fecha || 'N/A'}</Typography>
                              </Grid>
                              
                              
                              <Grid item xs={6}>
                                <Typography variant="body2" style={{fontWeight:"bold"}}>Entregado en:</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="body2" style={{color:  'green' }}>
                                  {item.sucursalentrega || 'N/A'}
                                </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="body2" style={{fontWeight:"bold"}}>Entregado por:</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="body2" style={{color:  'green' }}>
                                  {item.cajero || 'N/A'}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                  </>
                ))
              )}

        </Grid>

        {/* Diálogo de edición de datos */}
        <Dialog open={abrirEdicion} onClose={() => setAbrirEdicion(false)} maxWidth="md" fullWidth>
          <DialogTitle>Editar Datos de Entrega de Matrícula</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} style={{marginTop: 10}}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Nombres"
                  value={datosEdicion.nombres}
                  onChange={(e) => setDatosEdicion({...datosEdicion, nombres: e.target.value})}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Apellidos"
                  value={datosEdicion.apellidos}
                  onChange={(e) => setDatosEdicion({...datosEdicion, apellidos: e.target.value})}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Cédula"
                  value={datosEdicion.cedula}
                  onChange={(e) => setDatosEdicion({...datosEdicion, cedula: e.target.value})}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Fecha de Entrega"
                  type="date"
                  value={datosEdicion.fecha}
                  onChange={(e) => setDatosEdicion({...datosEdicion, fecha: e.target.value})}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  disabled={true}
                  label="Sucursal"
                  style={{color: 'green'}}
                  value={datosEdicion.sucursal}
                  onChange={(e) => setDatosEdicion({...datosEdicion, sucursal: e.target.value})}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Cajero"
                  disabled
                  style={{color: 'green'}}
                  value={datosEdicion.cajero}
                  onChange={(e) => setDatosEdicion({...datosEdicion, cajero: e.target.value})}
                  variant="outlined"
                  sx = {{
                    "&. MuiOutlinedInput-input.Mui-disabled": {
                      color: 'green',
                      WebkitTextFillColor: 'green',
                    }
                  }}
                />
              </Grid>
              
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setAbrirEdicion(false)} color="primary">
              Cancelar
            </Button>
            <Button onClick={guardarCambios}  variant="contained" style={{color:"white"}}>
              Guardar Cambios
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog para mostrar mensaje */}
        <Dialog
          open={mostrarMensaje}
          onClose={() => setMostrarMensaje(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <Typography variant="h6" fontWeight="bold">
              Información
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1">
              {mensaje}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => setMostrarMensaje(false)}
              style={{color: 'white'}}
            >
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog de confirmación para eliminación */}
        <Dialog
          open={abrirConfirmacionEliminar}
          onClose={() => setAbrirConfirmacionEliminar(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <Typography variant="h6" fontWeight="bold" color="error">
              Confirmar Eliminación
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1">
              ¿Está seguro que desea eliminar la matrícula del chasis <strong>{chasis}</strong>?
            </Typography>
            <Typography variant="body2" style={{marginTop: 10, color: 'red'}}>
              <strong>Advertencia:</strong> Esta acción no se puede deshacer.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setAbrirConfirmacionEliminar(false)}
              variant="contained"
              style={{color: 'white'}}
            > 
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={eliminarMatricula}
              style={{color: 'white'}}
            >
              Eliminar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal para mostrar PDF */}
        <PDFModal
          open={mostrarPDFModal}
          onClose={cerrarPDFModal}
          pdfUrl={pdfUrl}
          empresa={localStorage.getItem("empresa")}
          title="Recepción de Matrícula"
          showDownloadButton={true}
          showPrintButton={true}
        />
        

        
     </Box>

    );    
}

